import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { supabase } from './supabaseClient.ts'; // Import supabase client
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter> {/* Wrap App with BrowserRouter */}
      <QueryClientProvider client={queryClient}>
        <App supabase={supabase} />
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>
);
